import { render, staticRenderFns } from "./VariationSelect.vue?vue&type=template&id=4a939d05&"
import script from "./VariationSelect.vue?vue&type=script&lang=js&"
export * from "./VariationSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/plugin-ceres/plugin-ceres/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4a939d05')) {
      api.createRecord('4a939d05', component.options)
    } else {
      api.reload('4a939d05', component.options)
    }
    module.hot.accept("./VariationSelect.vue?vue&type=template&id=4a939d05&", function () {
      api.rerender('4a939d05', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/src/app/components/item/VariationSelect.vue"
export default component.exports